import pathfinder from '@fiverr-private/pathfinder';

export const getMySettingsUrl = ({ username, rollouts = {}, source }) => {
    if (rollouts.inCaribouAccountSettingsRollout) {
        return pathfinder('account_settings_v_5');
    }

    const editUserSectionParams = { section: 'account', id: username };
    const editUserSectionOptions = source ? { query: { source } } : undefined;

    return pathfinder('edit_user_section', editUserSectionParams, editUserSectionOptions);
};
